import React from 'react'
import Hero from './Hero'
import Features from './Features'
import Analytic from './Analytics'
import Footer from './Footer'

function Home() {
  return (
    <>
    <Hero/>
    <Features/>
    <Analytic/>
    <Footer/>
    </>
  )
}

export default Home